/**
 * Internal dependencies
 */
import {
    CURRENT_RENTAL_RECEIVE,
    CURRENT_RENTAL_REQUEST,
    CURRENT_RENTAL_REQUEST_SUCCESS,
    CURRENT_RENTAL_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import {getCurrentRental, requestingCurrentRental} from 'state/current-rental/selectors';

/**
 * [description]
 *
 * @param  {[type]} rental [description]
 * @return {[type]}         [description]
 */
export const setCurrentRental = (rental) => {
    return {
        type: CURRENT_RENTAL_RECEIVE,
    };
};

/**
 * [description]
 *
 * @param  {[type]} ) [description]
 * @return {[type]}   [description]
 */
export const requestCurrentRental = () => (dispatch) => {
    dispatch({
        type: CURRENT_RENTAL_REQUEST,
    });

    return cscom
        .currentRental()
        .list()
        .then((rental) => {
            dispatch({
                type: CURRENT_RENTAL_REQUEST_SUCCESS,
            });
            dispatch({
                type: CURRENT_RENTAL_RECEIVE,
                payload: {
                    rental,
                },
            });
            return rental;
        })
        .catch((error) => {
            if (error == 'Error: Not Found') {
                dispatch({
                    type: CURRENT_RENTAL_REQUEST_SUCCESS,
                });
                return;
            }
            dispatch({
                type: CURRENT_RENTAL_REQUEST_FAILURE,
                error,
            });
        });
};

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestCurrentRentalIfNotRequested = (...props) => async (dispatch, getState) => {
    
    const currentRental = getCurrentRental(getState());
    const requesting = requestingCurrentRental(getState());

    if (!currentRental && requesting == false) {
        return dispatch(requestCurrentRental(...props))
    }

    return currentRental;
}
